<template>
  <div>
    <SkeletonLoaderTitleUpdate v-show="showSkeleton" />

    <div class="ma-4">
      <div class="text-h4" v-show="!showSkeleton">Atualizar Rota - {{ description }}</div>
    </div>
    <div v-if="canRender">
      <CadastroRotas edicao="true" :_id="_id" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import SkeletonLoaderTitleUpdate from '@/componentes/SkeletonLoaderTitleUpdate'

import rotasStore from '../_store'

import CadastroRotas from './CadastroRotas'

export default {
  name: 'AtualizarRotas',
  props: {
    _id: String,
  },
  components: { CadastroRotas, SkeletonLoaderTitleUpdate },
  data: () => ({
    description: '',
    showSkeleton: false,
    canRender: false,
  }),
  computed: {
    ...mapGetters('atualizarRotaModulePABXStore', ['getRotaSelecionada']),
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'atualizarRotaModulePABXStore', rotasStore)

    await this.selecionarRota(this._id)
    this.description = this.getRotaSelecionada.description

    this.showSkeleton = false
    this.canRender = true
  },

  methods: {
    ...mapActions('atualizarRotaModulePABXStore', ['selecionarRota']),
  },
}
</script>
